"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllApprovalScopes = exports.ApprovalScopeEnum = void 0;
var ApprovalScopeEnum;
(function (ApprovalScopeEnum) {
    ApprovalScopeEnum["EXPENSE_PURCHASE"] = "EXPENSE_PURCHASE";
    ApprovalScopeEnum["EXPENSE_INVOICE"] = "EXPENSE_INVOICE";
    ApprovalScopeEnum["PURCHASE_ORDER"] = "PURCHASE_ORDER";
})(ApprovalScopeEnum || (exports.ApprovalScopeEnum = ApprovalScopeEnum = {}));
exports.AllApprovalScopes = Object.keys(ApprovalScopeEnum).filter((item) => isNaN(Number(item)));
